import { render, staticRenderFns } from "./MoleculeTeam.vue?vue&type=template&id=f76ff89a&scoped=true&"
import script from "./MoleculeTeam.vue?vue&type=script&lang=js&"
export * from "./MoleculeTeam.vue?vue&type=script&lang=js&"
import style0 from "./MoleculeTeam.vue?vue&type=style&index=0&id=f76ff89a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f76ff89a",
  null
  
)

export default component.exports